import { http_client } from "@/plugins/http_client";

const url = "/api/permuta/obtener";

const obtenerUnidades = async (filtros = {}) =>
  await http_client(`${url}/unidades`, filtros);

const obtenerLineasTrabajo = async (filtros = {}) =>
  await http_client(`${url}/linea-trabajo`, filtros);

const obtenerPlazas = async (filtros = {}) =>
  await http_client(`${url}/nombre-plaza`, filtros);

const obtenerInstituciones = async (filtros = {}) =>
  await http_client("api/instituciones", filtros);

const obtenerEstablecimientosPorInstitucion = async (filtros = {}) =>
  await http_client("api/establecimientos", filtros);

const obtenerEstablecimientoPorId = async (filtros = {}) =>
  await http_client("api/permuta/establecimiento", filtros);

const obtenerEmpleados = async (filtros = {}) =>
  await http_client("api/permuta/empleados", filtros);

const enviarSolicitud = async (data) => await http_client("api/permuta/v1/crear", data, "post", { headers: { "content-type": "multipart/form-data" } });

const modificarSolicitud = async (data) =>
  await http_client("api/permuta/modificar", data, "PUT");

const infoGlobal = async (filtros = {}) =>
  await http_client(
    "api/permuta/informacion/establecimiento-solicitante",
    filtros
  );

const ctlInstituciones = async (filtros = {}) =>
  await http_client("api/permuta/instituciones", filtros);

const buscarEmpleado = async (document) => {
  return await http_client('api/permuta/empleado/search', { document });
}

const crearSolicitud = async (data) =>
  await http_client("api/permuta/crear", data, "post", { headers: { "content-type": "multipart/form-data" } });

const verSolicitud = async (idSolicitud, esMiPermuta = 0) => 
  await http_client("api/permuta/persona/permuta", { idSolicitud, esMiPermuta });

const aceptarSolicitud = async (data) =>
  await http_client("api/permuta/v1/aceptar", data, "put");

const rechazarSolicitud = async (data) =>
  await http_client("api/permuta/denegar", data, "post");

const observarSolicitud = async (data) =>
  await http_client("api/permuta/justificar", data, "post");

const descargarDocumento = async(idDocumento) => 
  await http_client(`api/permuta/descargar-documento/${idDocumento}`);

const eliminarDocumento = async(idDocumento) => 
  await http_client(`api/permuta/eliminar-documento/${idDocumento}`, {}, "delete");

const guardarDocumento = async(data) => 
  await http_client("api/permuta/guardar-documento", data, "post", { headers: { "content-type": "multipart/form-data" } });

const verDocumento = async(idDocumento) => 
  await http_client(`api/permuta/ver-documento/${idDocumento}`);

const enviarTitularRH = async (data) =>
  await http_client("api/permuta/movimiento/titular-a-acuerdo", data, "post");

const descargarAcuerdo = async (data) =>
  await http_client('api/permuta/descargar/acuerdo', data);

// FASE RRHH CENTRAL ENVIA ACUERDO A TITULAR
const enviarAcuerdoTitular = async (data) => {
  return await http_client('api/permuta/movimiento/rrhh-central-acuerdo', data, 'post', { headers: { 'content-type': 'multipart/form-data' } });
}

// FASE PARA ENVIAR ACUERDO FIRMADO A RRHH
const enviarAcuerdoRH = async (data) => {
  return await http_client('api/permuta/subir-acuerdo-firmado-titular', data, 'post', { headers: { 'content-type': 'multipart/form-data' } });
}

// FASE ENVIAR RRHH CENTRAL A RRHH B
const enviarAcuerdoRHCentral = async (data) => {
  return await http_client('api/permuta/movimiento/enviar-establecimiento-b', data, 'post');
}

const enviarRRHHATitular = async (data) =>
  await http_client("/api/permuta/movimiento/rrhh-a-avanzar", data, "post");

const enviarRRHHBTitular = async (data) =>
  await http_client("/api/permuta/movimiento/rrhh-b-avanzar", data, "post");

// ULTIMA FASE RRHH CENTRAL NOTIFICA INVOLUCRADOS
const enviarNotificacion = async (data) => {
  return await http_client('api/permuta/movimiento/rrhh-central-notificar', data, 'post');
}

// Enviar de RRHH Centrales a Titulares
const enviarCentralTitular = async (data) => 
  await http_client("api/permuta/movimiento/central-a-titular", data, "post");


export default {
  obtenerUnidades,
  obtenerLineasTrabajo,
  obtenerPlazas,
  obtenerInstituciones,
  obtenerEstablecimientosPorInstitucion,
  obtenerEstablecimientoPorId,
  obtenerEmpleados,
  enviarSolicitud,
  modificarSolicitud,
  infoGlobal,
  ctlInstituciones,
  buscarEmpleado,
  crearSolicitud,
  verSolicitud,
  aceptarSolicitud,
  rechazarSolicitud,
  observarSolicitud,
  descargarDocumento,
  eliminarDocumento,
  guardarDocumento,
  verDocumento,
  enviarTitularRH,
  descargarAcuerdo,
  enviarAcuerdoTitular,
  enviarAcuerdoRH,
  enviarAcuerdoRHCentral,
  enviarRRHHATitular,
  enviarRRHHBTitular,
  enviarNotificacion,
  enviarCentralTitular,
};
